import {Component} from 'react';
import {connect} from 'react-redux';
import handlers from 'react-handlers';
import injectSheet from 'react-jss';

import Dialog from './Dialog';
import {ControlGroup} from '-/components/fields/Control';
import {RadioGroup, Radio} from '-/components/fields/RadioGroup';
import VehicleInfoService from '-/services/VehicleInfoService';
import {renderFieldErrors, isMobile} from '-/util/util';
import Button from '-/components/general/Button';
import {rem, userSelect} from '-/styles/utils';

const styles = () => ({
    buttons: {
        margin: `${rem(18)} 0 0`,
        padding: `0 ${rem(30)} ${rem(25)}`
    },
    row: {
        display: 'flex',
        '&:not(:first-of-type)': {
            marginTop: rem(15)
        },
        '& $cell': {
            flex: 1
        }
    },
    cell: {
        '&:not(:only-child)': {
            '&:first-child': {
                marginRight: rem(5)
            }
        },
        '& a, & label': {
            ...userSelect('none'),
            padding: `${rem(10)} 0`,
            border: '1px solid #d2d2d2',
            margin: 0,
            letterSpacing: rem(1.2),
            lineHeight: rem(22),
            whiteSpace: 'nowrap',
            boxShadow: '0 1px 8px rgba(0, 0, 0, 0.12)',
            '& i': {
                verticalAlign: 'middle'
            }
        },
        '&:last-child': {
            '& a, & label': {
                color: 'white',
                boxShadow: '0 5px 4px rgba(0, 0, 0, 0.19)'
            }
        }
    }
});

class VinReminder extends Component {
    constructor(props) {
        super(props);

        const {email, cellphone} = props;
        this.state = {
            errorMessages: [],
            showErrors: false,
            extraStipTransportType: email && !cellphone ? 'EMAIL' : null
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    getErrorMessages() {
        const {extraStipTransportType} = this.state;
        const messages = [];

        if (!extraStipTransportType) {
            messages.push('Please select a communication option');
        }

        return messages;
    }

    onInputChange(value) {
        const {showErrors} = this.state;
        this.setState({
            showErrors,
            errorMessages: [],
            extraStipTransportType: value
        });
    }

    handleClose = () => {
        VehicleInfoService.closeDialog();
    }

    handleSave() {
        const {callback, stipType} = this.props;
        const {extraStipTransportType} = this.state;
        const errorMessages = this.getErrorMessages();
        this.setState({errorMessages, showErrors: true});

        if (!errorMessages.length) {
            callback(extraStipTransportType, stipType);
        }
    }

    render() {
        const {cellphone, email, stipType, classes = {}} = this.props;
        const {errorMessages, showErrors, extraStipTransportType} = this.state;
        const stipTypes = stipType.split(',');

        let isEmailChecked = !cellphone || (cellphone && extraStipTransportType === 'EMAIL');
        let message = '';
        
        if (stipTypes.length > 1) {
            message = 'Where can we send a secure link for you to upload additional documents/information?';
        } else if (stipTypes.includes('VIN')) {
            message = 'No problem not being able to input your VIN now. Where can we send the link to input your VIN later?';
        } else if (stipTypes.includes('REG')) {
            message = 'Where can we send a secure link for you to upload a picture of your Vehicle Registration?';
        } else if (stipTypes.includes('OLD')) {
            message = 'Where can we send a secure link for you to upload a copy of your current vehicle loan contract?';
        }

        return (
            <Dialog>
                <form>
                    <div className="step-screen">
                        <h3>{message}</h3>
                        <br />
                        <ControlGroup labelWidth={200}>
                            <RadioGroup
                                labelWidth={200}
                                vertical={isMobile()}
                                label=""
                                onChange={handlers(this.onInputChange)}>
                                <Radio
                                    name="extraStipTransportType"
                                    value="EMAIL"
                                    label={`Email (${email})`}
                                    id="extraStipTransportType-email"
                                    checked={isEmailChecked} />

                                {cellphone &&
                                    <Radio
                                        name="extraStipTransportType"
                                        value="SMS"
                                        label={`Text (${cellphone})`}
                                        id="extraStipTransportType-sms" />
                                }
                            </RadioGroup>
                            {showErrors && renderFieldErrors(errorMessages)}
                            <section className={classes.buttons}>
                                <div className={classes.row}>
                                    <div className={classes.cell}>
                                        <Button tag="a" onClick={this.handleClose}>Close</Button>
                                    </div>
                                    <div className={classes.cell}>
                                        <Button tag="a" onClick={this.handleSave}>Save</Button>
                                    </div>
                                </div>
                            </section>
                        </ControlGroup>
                    </div>
                </form>
            </Dialog>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const {
        callback,
        data: {
            email,
            cellphone,
            stipType
        } = {}
    } = ownProps;

    return {
        cellphone,
        email,
        callback,
        stipType
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(VinReminder));
